<template>
    <b-row>
        <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
            <div class="filter-wrapper">
                <b-form-select v-model="selectedOption" :options="options" />
            </div>
        </b-col>
        <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
            <b-form autocomplete="off">           
                <div class="filter-wrapper">
                    <b-input-group prepend>
                        <b-form-input type="text" autocomplete="off" placeholder="Search" v-model="keyword" @keyup.native="search(true)" maxlength="30">
                        </b-form-input>
                        <b-dropdown text="Advanced" variant="primary" slot="append">
                            <b-dropdown-item
                                v-for="(option, index) in advancedOptions"
                                :key="'advance_option_' + index"
                                @click="selectAdvanceOption(option.value)">
                                {{ option.text }}
                                <i class="ml-1" v-if="selectedAdvancedOption === option.value">
                                    <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1" style="margin-top: -4px;">
                                </i>
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-input-group>
                </div>
            </b-form>
        </b-col>
        <b-col sm="3" md="3">
            <b-button
                variant="primary"
                class="d-inline-block new-button align-top"
                @click="showModal">
                + New Store Voucher
            </b-button>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "StoreVoucherToolbar",
    data() {
        return {
            selectedOption: null,
            options: [
                { value: null, text: "All Categories" }
            ],
            keyword: ""
        }
    },
    computed: {
        ...mapState("estoreVouchers", [
            "advancedOptions",
            "selectedAdvancedOption",
            // "keyword"
        ])
    },
    methods: {
        showModal: function() {
            this.$store.commit("estoreVouchers/setModal", {
                type: "new",
                status: true
            });
        },
        selectAdvanceOption(value) {
            this.$store.commit("estoreVouchers/setSelectedAdvancedOption", value);
            // if (this.keyword.trim() !== "") {
                this.search(true);
            // }
        },
        async search(newSearch = false) {
            let param = {
                payload: {
                    filters: {
                        visibility: this.selectedAdvancedOption,
                        keyword: this.keyword,
                        column: "all"
                    }
                },
                page: newSearch === true ? 1 : page
            };

            if (this.keyword.trim() === "") {
                this.$store.dispatch("estoreVouchers/getStoreVouchers", param);
            }

            if (newSearch) {
                this.$store.commit("estoreVouchers/setEmptyText", "Searching...");
                this.$store.commit("estoreVouchers/setIsSearching", true);
            }

            let _this = this;
            this.$store.dispatch("estoreVouchers/getStoreVouchers", param).then(() => {
                _this.$store.commit("estoreVouchers/setEmptyText", 'No results found for "' + _this.keyword + '"');
                _this.$store.commit("estoreVouchers/setIsSearching", false);
            });
        }
    },
    watch: {
        keyword: function(value) {
            this.$store.commit("estoreVouchers/setKeyword", value);
        }
    }
}
</script>
